/* Bioteine - Search overlay (v4).
 * Full-width top panel pattern (Huisman-style).
 * - Opens on [data-bt-search-open] / Cmd+K.
 * - Tracks the last 6 searches in localStorage, renders them as removable chips.
 * - Live predictive results via /search/suggest.json when typing.
 * - When idle: shows popular searches + recommended-products carousel.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'bt_search_recent';
  var MAX_RECENT = 6;

  function loadRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function addRecent(term) {
    var t = (term || '').trim();
    if (!t) return;
    var list = loadRecent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
    list.unshift(t);
    list = list.slice(0, MAX_RECENT);
    saveRecent(list);
  }
  function removeRecent(term) {
    saveRecent(loadRecent().filter(function (x) { return x !== term; }));
  }
  function clearRecent() {
    saveRecent([]);
  }

  function escape(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    var euros = parseFloat(cents) / 100;
    if (isNaN(euros)) return '';
    return '€' + euros.toFixed(2).replace('.', ',');
  }

  function priceCents(v) {
    if (v === undefined || v === null || v === '') return 0;
    var s = String(v);
    if (s.indexOf('.') !== -1 || s.indexOf(',') !== -1) {
      return Math.round(parseFloat(s.replace(',', '.')) * 100);
    }
    return parseInt(s, 10) || 0;
  }

  function init() {
    var overlay = document.querySelector('[data-bt-search]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-bt-search-input]');
    var live = overlay.querySelector('[data-bt-search-live]');
    var recentWrap = overlay.querySelector('[data-bt-search-recent]');
    var recentChips = overlay.querySelector('[data-bt-search-recent-chips]');
    var recentClear = overlay.querySelector('[data-bt-search-recent-clear]');
    var recTrack = overlay.querySelector('[data-bt-rec-track]');
    var recPrev = overlay.querySelector('[data-bt-rec-prev]');
    var recNext = overlay.querySelector('[data-bt-rec-next]');
    var form = overlay.querySelector('form');
    if (!input || !live) return;

    var openTriggers = document.querySelectorAll('[data-bt-search-open]');
    var closeTriggers = overlay.querySelectorAll('[data-bt-search-close]');

    function renderRecent() {
      var list = loadRecent();
      if (!list.length) {
        if (recentChips) recentChips.innerHTML = '';
        if (recentWrap) {
          recentWrap.hidden = true;
          recentWrap.setAttribute('hidden', '');
        }
        return;
      }
      recentChips.innerHTML = list.map(function (t) {
        var esc = escape(t);
        return '<span class="bt-search__recent-chip">'
          + '<a href="/search?q=' + encodeURIComponent(t) + '" data-bt-recent-use="' + esc + '">' + esc + '</a>'
          + '<button type="button" class="bt-search__recent-chip-x" data-bt-recent-remove="' + esc + '" aria-label="Verwijder ' + esc + '">×</button>'
          + '</span>';
      }).join('');
      if (recentWrap) {
        recentWrap.hidden = false;
        recentWrap.removeAttribute('hidden');
      }
    }

    function open() {
      overlay.hidden = false;
      overlay.removeAttribute('hidden');
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bt-no-scroll');
      renderRecent();
      setTimeout(function () { input.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.classList.remove('is-searching');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bt-no-scroll');
      setTimeout(function () {
        if (!overlay.classList.contains('is-open')) overlay.setAttribute('hidden', '');
      }, 300);
    }

    openTriggers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    closeTriggers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault(); open();
      }
    });

    // Recent chip interactions (event delegation)
    if (recentChips) {
      recentChips.addEventListener('click', function (e) {
        var x = e.target.closest('[data-bt-recent-remove]');
        if (x) {
          e.preventDefault();
          removeRecent(x.getAttribute('data-bt-recent-remove'));
          renderRecent();
          return;
        }
      });
    }
    if (recentClear) {
      recentClear.addEventListener('click', function () {
        clearRecent();
        renderRecent();
      });
    }

    // Submit logs the term as recent before letting the form submit
    if (form) {
      form.addEventListener('submit', function () {
        addRecent(input.value);
      });
    }

    // Carousel arrows
    if (recPrev && recTrack) {
      recPrev.addEventListener('click', function () {
        recTrack.scrollBy({ left: -360, behavior: 'smooth' });
      });
    }
    if (recNext && recTrack) {
      recNext.addEventListener('click', function () {
        recTrack.scrollBy({ left: 360, behavior: 'smooth' });
      });
    }

    // Live predictive search
    var debounceTimer = null;
    var lastQ = '';

    function renderGroup(title, items, renderer) {
      if (!items || !items.length) return '';
      return '<div class="bt-search__live-group">'
        + '<h3 class="bt-search__live-group-title">' + escape(title) + '</h3>'
        + '<div class="bt-search__live-items">'
        + items.slice(0, 8).map(renderer).join('')
        + '</div></div>';
    }
    function productItem(p) {
      var price = '';
      if (p.variants && p.variants[0]) {
        var c = priceCents(p.variants[0].price);
        price = '<span class="bt-search__live-item-price">' + money(c) + '</span>';
      }
      var img = p.featured_image && p.featured_image.url
        ? '<span class="bt-search__live-item-media"><img src="' + escape(p.featured_image.url) + '" alt="" loading="lazy" width="48" height="48"></span>'
        : '<span class="bt-search__live-item-media"></span>';
      return '<a href="' + escape(p.url) + '" class="bt-search__live-item">'
        + img
        + '<span style="display:flex;flex-direction:column;gap:2px;min-width:0;flex:1;">'
        + '<span class="bt-search__live-item-title">' + escape(p.title) + '</span>'
        + price
        + '</span></a>';
    }
    function linkItem(o) {
      return '<a href="' + escape(o.url) + '" class="bt-search__live-item">'
        + '<span class="bt-search__live-item-title">' + escape(o.title) + '</span></a>';
    }

    function query(q) {
      if (!q || q.length < 2) {
        overlay.classList.remove('is-searching');
        live.hidden = true;
        live.innerHTML = '';
        return;
      }
      overlay.classList.add('is-searching');
      live.hidden = false;
      live.innerHTML = '<div class="bt-search__live-empty">Zoeken...</div>';

      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== input.value.trim()) return;
          var r = (data.resources && data.resources.results) || {};
          var hasAny = (r.products && r.products.length)
            || (r.collections && r.collections.length)
            || (r.pages && r.pages.length)
            || (r.articles && r.articles.length);
          if (!hasAny) {
            live.innerHTML = '<div class="bt-search__live-empty">Geen resultaten voor "' + escape(q) + '". Probeer een ander woord.</div>';
            return;
          }
          var html = '';
          html += renderGroup('Producten', r.products, productItem);
          html += renderGroup('Collecties', r.collections, linkItem);
          html += renderGroup('Artikelen', r.articles, linkItem);
          html += renderGroup('Paginas', r.pages, linkItem);
          if (r.products && r.products.length >= 8) {
            html += '<div style="margin-top:8px"><a href="/search?q=' + encodeURIComponent(q) + '" style="color:var(--bt-sage-dark);font-size:14px;text-decoration:underline;">Alle resultaten voor "' + escape(q) + '" →</a></div>';
          }
          live.innerHTML = html;
        })
        .catch(function () {
          live.innerHTML = '<div class="bt-search__live-empty">Er ging iets mis. Probeer opnieuw.</div>';
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { query(q); }, 180);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
